module.exports = __webpack_public_path__ + "static/img/mobile.c815afd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile.png
// module id = HXsc
// module chunks = 0